import {LTServices} from "../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {Map as OlMap} from 'ol';
import TileLayer from "ol/layer/Tile";
import {default as Base} from 'ol/layer/Base';
import {CollectionEvent} from "ol/Collection";

export class TileLoadIndicator implements ng.IDirective {
	restrict = 'E'; //attribute or element
	transclude = true;
	replace = true;
	elementClass = 'lt-tile-load-indicator';
	scope = {
		ltResolutions: '='
	};
	template = '<div class="tile-load-indicator"></div>';
	map: OlMap = null;
	constructor(protected mapService: IMapService) {
		this.link = ($scope: ng.IScope, element: ng.IAugmentedJQuery,
					 attrs: ng.IAttributes) => {
			let loading = 0;
			let loaded = 0;
			let width = 0;

			let show = () => {
				element[0].style.visibility = '';

			};

			let hide = () => {
				if (loaded == loading) {
					element[0].style.visibility = 'hidden';
					element[0].style.width = '0';
				}
			};


			let update = () => {
				// Smooths out the indicator so it only moves forward.
				let newWidth = (loaded / loading * 100);
				if (newWidth == 0 || newWidth > width) {
					element[0].style.width = width.toFixed(1) + '%';
					if (loading === loaded) {
						loading = 0;
						loaded = 0;
						width = 0;
						setTimeout(hide, 500);
					}
					width = newWidth;
				}

			};

			let addLoad = () => {
				if (loading === 0) {
					show();
				}
				++loading;
				update();
			};

			let addLoaded = () => {
				setTimeout(() => {
					++loaded;
					update();
				}, 100);
			};

			let listenToLayer = (layer : Base) => {
				if (layer.get('tileLoadingListening')) {
					return;
				}
				if (layer instanceof TileLayer) {
					try {
                        layer.getSource().on('tileloadstart', addLoad);

                        layer.getSource().on('tileloadend', addLoaded);

                        layer.getSource().on('tileloaderror', addLoaded);

                        layer.set('tileLoadingListening', true);
					} catch (e) {
						console.warn(e);
                    }

				}
			};

			mapService.mapPromise.then((map) => {
				let layers = map.getLayers();
				layers.getArray().forEach(listenToLayer);

				layers.on('add', (ev : CollectionEvent<any>) => {
					let el = ev.element;
					listenToLayer(el);
				});
			});
		};
	}

	link: ($scope: ng.IScope, elem: ng.IAugmentedJQuery,
		   attrs: ng.IAttributes) => void = null;

	static factory(): ng.IDirectiveFactory {
		const directive = (mapService : IMapService ) => new TileLoadIndicator(mapService);
		directive.$inject = ['landcareMapService'];
		return directive;
	}
}